import React, { useState, useEffect } from 'react';

// Giunzioni configuration rules
const GIUNZIONI_CONFIGS = {
    'lineare': {
        code: 'N6-LINEARE',
        name: 'N6-LINEARE',
        image: '/images/accessories/GIUNZIONI/SEL-GLINEARE.png',
        description: 'Giunzione lineare per profili',
        finishOptions: [
            { code: '', name: 'Unica Finitura', color: '#E0E0E0' }
        ],
        validForModels: 'TUTTI',
        hasMinimums: false
    },
    'angolare': {
        code: 'N6-ANGOLARE',
        name: 'N6-ANGOLARE',
        image: '/images/accessories/GIUNZIONI/SEL-GANGOLARE.png',
        description: 'Giunzione angolare per profili',
        finishOptions: [
            { code: '', name: 'Unica Finitura', color: '#E0E0E0' }
        ],
        validForModels: 'TUTTI',
        hasMinimums: false
    },
    'cc': {
        code: 'N6-CC',
        name: 'N6-CC',
        image: '/images/accessories/GIUNZIONI/SEL-COPRICARTER.png',
        description: 'Giunzione con due finiture',
        finishOptions: [
            { code: '-N', name: 'RAL9005 Opaco', color: '#000000' },
            { code: '-G', name: 'RAL7025 Opaco', color: '#808080' }
        ],
        validForModels: 'TUTTI ESCLUSO NINFA 50-N',
        hasMinimums: false
    }
};

export const BracketSelector = ({ onSelect, initialValues = {}, isEditMode = false, profileType: propProfileType }) => {
    // profileType is available but not used for filtering since all brackets are universal
    // Keeping it for consistency with other selectors

    // State management
    const [step, setStep] = useState(1);
    const [selectedType, setSelectedType] = useState(initialValues?.giunzioneType || '');
    const [selectedFinish, setSelectedFinish] = useState(initialValues?.giunzioneFinish || null);
    const [quantity, setQuantity] = useState(initialValues?.quantity || 1);

    // Reset when initialValues change
    useEffect(() => {
        if (initialValues?.giunzioneType) {
            setSelectedType(initialValues.giunzioneType);
        }
        if (initialValues?.giunzioneFinish) {
            setSelectedFinish(initialValues.giunzioneFinish);
        }
        if (initialValues?.quantity) {
            setQuantity(initialValues.quantity);
        }
    }, [initialValues]);

    const handleTypeSelect = (type) => {
        setSelectedType(type);
        setSelectedFinish(null); // Reset finish when type changes
        setStep(2);
    };

    const handleFinishSelect = (finishCode) => {
        setSelectedFinish(finishCode);
        setStep(3);
    };

    const handleQuantityChange = (e) => {
        const raw = e.target.value;
        if (raw === '') {
            setQuantity('');
            return;
        }
        const value = parseInt(raw);
        if (!isNaN(value) && value > 0) {
            setQuantity(value);
        }
    };

    const generateProductCodes = () => {
        console.log('generateProductCodes called with:', { selectedType, selectedFinish, quantity });
        if (!selectedType || selectedFinish === null || selectedFinish === undefined) {
            console.log('generateProductCodes returning empty array');
            return [];
        }

        const config = GIUNZIONI_CONFIGS[selectedType];
        const finishConfig = config.finishOptions.find(f => f.code === selectedFinish);
        const productCode = config.code + selectedFinish;

        const result = [{
            code: productCode,
            quantity: quantity,
            description: `${config.name} - ${finishConfig?.name || 'Finitura Standard'}`,
            category: 'main'
        }];

        console.log('generateProductCodes returning:', result);
        return result;
    };

    const handleSubmit = () => {
        const productCodes = generateProductCodes();
        const giunzioneConfig = {
            productCodes,
            giunzioneType: selectedType,
            giunzioneFinish: selectedFinish,
            quantity: quantity,
            finish: GIUNZIONI_CONFIGS[selectedType]?.finishOptions.find(f => f.code === selectedFinish)?.name || 'Finitura Standard'
        };

        console.log('Giunzione config being sent:', giunzioneConfig);
        onSelect(giunzioneConfig);
    };

    // Render appropriate step
    const renderStep = () => {
        switch (step) {
            case 1:
                return (
                    <div className="text-center">
                        <h2 className="text-xl font-bold mb-4">Seleziona il Tipo di Giunzione</h2>
                        <p className="text-gray-600 mb-6">Scegli il tipo di giunzione per i tuoi profili</p>

                        <div className="grid grid-cols-2 sm:grid-cols-3 gap-4 mb-6">
                            {Object.entries(GIUNZIONI_CONFIGS).map(([key, config]) => (
                                <button
                                    key={key}
                                    onClick={() => handleTypeSelect(key)}
                                    className={`p-4 border-2 rounded-xl transition-all ${selectedType === key ? 'bg-red-100 border-red-500' : 'border-gray-200 bg-white hover:border-red-500 hover:shadow-lg'}`}
                                >
                                    <div className="flex flex-col items-center">
                                        {config.image ? (
                                            <div className="w-full h-20 mb-2 flex items-center justify-center">
                                                <img
                                                    src={config.image}
                                                    alt={config.name}
                                                    className="h-16 object-contain"
                                                    onError={(e) => {
                                                        e.target.style.display = 'none';
                                                        e.target.nextElementSibling.style.display = 'flex';
                                                    }}
                                                />
                                                <div className="w-16 h-16 hidden items-center justify-center bg-red-50 rounded-full">
                                                    <span className="text-2xl font-bold">
                                                        {key === 'lineare' ? '─' : key === 'angolare' ? '└' : 'CC'}
                                                    </span>
                                                </div>
                                            </div>
                                        ) : (
                                            <div className="w-16 h-16 flex items-center justify-center mb-2 bg-red-50 rounded-full">
                                                <span className="text-2xl font-bold">
                                                    {key === 'lineare' ? '─' : key === 'angolare' ? '└' : 'CC'}
                                                </span>
                                            </div>
                                        )}
                                        <span className="font-medium text-gray-700">{config.name}</span>
                                        <span className="text-sm text-gray-500 mt-1">{config.description}</span>
                                        <span className="text-xs text-red-600 mt-1">{config.validForModels}</span>
                                    </div>
                                </button>
                            ))}
                        </div>
                    </div>
                );

            case 2:
                const typeConfig = GIUNZIONI_CONFIGS[selectedType];
                if (!typeConfig) return null;

                return (
                    <div className="text-center">
                        <h2 className="text-xl font-bold mb-4">Seleziona la Finitura</h2>
                        <p className="text-gray-600 mb-6">Scegli la finitura per {typeConfig.name}</p>

                        <div className="grid grid-cols-2 sm:grid-cols-3 gap-4 mb-6">
                            {typeConfig.finishOptions.map((finishOption) => (
                                <button
                                    key={finishOption.code}
                                    onClick={() => handleFinishSelect(finishOption.code)}
                                    className={`p-4 border rounded-lg ${selectedFinish === finishOption.code ? 'bg-red-100 border-red-500' : 'border-gray-300'} hover:shadow-md transition-all`}
                                >
                                    <div className="flex flex-col items-center">
                                        <div
                                            className="w-16 h-16 rounded-full mb-2 border border-gray-300"
                                            style={{ backgroundColor: finishOption.color }}
                                        ></div>
                                        <span className="font-medium">{finishOption.name}</span>
                                        {finishOption.code && (
                                            <span className="text-sm text-gray-500">({finishOption.code})</span>
                                        )}
                                    </div>
                                </button>
                            ))}
                        </div>

                        <div className="flex justify-center space-x-4 mt-6">
                            <button
                                onClick={() => setStep(1)}
                                className="px-6 py-2 bg-gray-200 rounded-lg hover:bg-gray-300"
                            >
                                Indietro
                            </button>
                            {selectedFinish !== null && selectedFinish !== undefined && (
                                <button
                                    onClick={() => setStep(3)}
                                    className="px-6 py-2 bg-red-500 text-white rounded-lg hover:bg-red-600"
                                >
                                    Continua
                                </button>
                            )}
                        </div>
                    </div>
                );

            case 3:
                const productCodes = generateProductCodes();

                return (
                    <div className="text-center">
                        <h2 className="text-xl font-bold mb-4">Configura la Quantità</h2>

                        <div className="max-w-md mx-auto p-4 border rounded-lg border-gray-200 mb-6">
                            <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3 mb-4">
                                <div className="text-left flex-1">
                                    <span className="font-medium">{GIUNZIONI_CONFIGS[selectedType]?.name}</span>
                                    <p className="text-sm text-gray-500">
                                        {GIUNZIONI_CONFIGS[selectedType]?.finishOptions.find(f => f.code === selectedFinish)?.name}
                                    </p>
                                </div>
                                <div className="flex items-center space-x-3 w-full sm:w-auto">
                                    <label className="text-sm font-medium">Quantità:</label>
                                    <input
                                        type="number"
                                        inputMode="numeric"
                                        pattern="[0-9]*"
                                        min="1"
                                        value={quantity ?? ''}
                                        onChange={handleQuantityChange}
                                        className="flex-1 sm:flex-none sm:w-24 p-3 text-base border rounded-md text-center"
                                    />
                                </div>
                            </div>
                        </div>

                        <div className="bg-gray-50 p-4 rounded-lg mb-6">
                            <h3 className="font-medium mb-2">Riepilogo Prodotto</h3>
                            {productCodes.map((product, index) => (
                                <div key={index} className="text-sm">
                                    <span className="font-medium">{product.code}</span> -
                                    Qty: {product.quantity} - {product.description}
                                </div>
                            ))}
                        </div>

                        <div className="flex justify-center space-x-4 mt-6">
                            <button
                                onClick={() => setStep(2)}
                                className="px-6 py-2 bg-gray-200 rounded-lg hover:bg-gray-300"
                            >
                                Indietro
                            </button>
                            <button
                                onClick={handleSubmit}
                                disabled={!quantity || quantity === '' || parseInt(quantity) < 1}
                                className="px-6 py-2 bg-red-500 text-white rounded-lg hover:bg-red-600 disabled:opacity-50 disabled:cursor-not-allowed"
                            >
                                {isEditMode ? 'Aggiorna Giunzione' : 'Aggiungi al Carrello'}
                            </button>
                        </div>
                    </div>
                );

            default:
                return null;
        }
    };

    return (
        <div className="space-y-6">
            {renderStep()}
        </div>
    );
};

export default BracketSelector;